package com.fireavert.properties.shared.client

import com.fireavert.properties.delete_property_admin_dialog.client.AddRemovePropertyAdminValidator

class AddRemovePropertyAdminRowController(private val validator: AddRemovePropertyAdminValidator) {
    fun checkName(name: String) = validator.checkName(name)
    fun checkPhone(phone: String) = validator.checkPhone(phone)
    fun checkEmail(email: String) = validator.checkEmail(email)
    fun checkPassword(password: String) = validator.checkPassword(password)
}